import type { ReactNode } from 'react';
import { iconGlyph } from '../theme/categoryIcons';
import styles from './CategoryIcon.module.css';

/**
 * One category icon, drawn with the **app's own font file**
 * (02-requirements.md §Category Icons) — so what an administrator sees while
 * choosing is the drawing the phone will make, not an approximation of it.
 *
 * `aria-hidden`: every place this appears already names the category in text
 * beside it, and a Private Use Area codepoint read aloud is noise.
 */
export function CategoryIcon({
  name,
  size = 'tile',
}: {
  name: string | null | undefined;
  /** `tile` matches the app's 48px grid glyph; `row` is the list's smaller one. */
  size?: 'tile' | 'row';
}): ReactNode {
  const glyph = iconGlyph(name);
  return (
    <span
      aria-hidden="true"
      className={size === 'tile' ? `${styles.icon} ${styles.tile}` : `${styles.icon} ${styles.row}`}
    >
      {glyph}
    </span>
  );
}
